<template>
    <v-container fluid>
        <v-row>
            <v-col>
                <v-card height="calc(100vh - (280px))" elevation="0">
                    <v-row>
                        <v-col class="text-start">
                            <v-text-field label="Buscar" dense v-model="search" clearable
                                prepend-inner-icon="mdi-magnify"></v-text-field>
                        </v-col>
                        <v-col class="text-end">
                            <v-btn color="primary" @click="showNewAddressModal = true">
                                <v-icon>
                                    mdi-plus
                                </v-icon>
                                Agregar dirección
                            </v-btn>
                        </v-col>
                        <v-col cols="auto">
                            <v-btn color="primary" @click="fetchData">
                                <v-icon>mdi-refresh</v-icon>
                                Recargar
                            </v-btn>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <v-data-table fixed-header height="calc(100vh - (400px))" :headers="headers"
                                :items="addressList" :items-per-page="rowsPerPage" no-data-text="No hay direcciones"
                                loading-text="Cargando direcciones..." :page.sync="page" hide-default-footer
                                :loading="fetchingData" item-key="_id">
                                <template #[`item._id`]="{ item }">
                                    <v-menu :rounded="true" offset-y>
                                        <template v-slot:activator="{ attrs, on }">
                                            <v-btn class="white--text" v-bind="attrs" v-on="on" text fab x-small>
                                                <v-icon color="black"> mdi-dots-vertical </v-icon>
                                            </v-btn>
                                        </template>
                                        <v-list>
                                            <v-list-item @click="handleUpdateSelection(item)">
                                                <v-list-item-title > Actualizar
                                                </v-list-item-title>
                                            </v-list-item>
                                            <v-list-item @click="handleDeleteSelection(item)">
                                                <v-list-item-title>Eliminar</v-list-item-title>
                                            </v-list-item>
                                        </v-list>
                                    </v-menu>
                                </template>
                            </v-data-table>
                            <v-pagination v-model="page" :length="numPages" :total-visible="rowsPerPage"
                                color="primary"></v-pagination>
                        </v-col>
                    </v-row>
                </v-card>
            </v-col>
        </v-row>
        <!-- modals -->
        <NewAddressModal v-model="showNewAddressModal" v-if="showNewAddressModal" @update="handleUpdateTable" />
        <DeleteAddressModal v-model="showDeleteAddressModal" v-if="showDeleteAddressModal"
            @update="handleUpdateTable" />
        <UpdateAddressModal v-model="showUpdateAddressModal" v-if="showUpdateAddressModal"
            @update="handleUpdateTable" />
    </v-container>
</template>

<script>
// vue 
import { mapActions, mapMutations } from 'vuex';
// components
import NewAddressModal from '../modals/NewAddressModal.vue';
import DeleteAddressModal from '../modals/DeleteAddressModal.vue';
import UpdateAddressModal from '../modals/UpdateAddressModal.vue';

export default {
    components: {
        NewAddressModal,
        DeleteAddressModal,
        UpdateAddressModal
    },
    data: () => ({
        headers: [
            { text: "Nombre (alias)", align: "start", value: "name", sortable: false },
            { text: "Dirección", align: "start", value: "address", sortable: false },
            { text: "Contacto", value: "contact", sortable: false },
            {
                text: "Telefono",
                align: "center",
                value: "phone",
                sortable: false,
            },
            {
                text: "Correo",
                align: "center",
                value: "email",
                sortable: false,
            },
            {
                text: "Acciones",
                align: "center",
                value: "_id",
                sortable: false,
            },
        ],
        addressList: [],
        rowsPerPage: 10,
        numPages: 1,
        page: 1,
        search: null,
        fetchingData: false,
        // modals
        showNewAddressModal: false,
        showDeleteAddressModal: false,
        showUpdateAddressModal: false,
    }),
    async mounted() {
        await this.fetchData()
    },
    methods: {
        ...mapActions("address", ["getAddress"]),
        ...mapMutations("address", ["SET_ADDRESS"]),
        async handleUpdateTable() {
            await this.fetchData()
        },
        async fetchData() {
            try {
                this.fetchingData = true
                let payload = {
                    search: this.search,
                    page: this.page,
                    rowPerPage: 10
                }
                let response = await this.getAddress(payload)
                this.addressList = response.addressList
                this.numPages = response.pages
            } catch (error) {
                console.log(error);
                this.$swal({
                    icon: "error",
                    title: `Algo salio mal al crear OP. Error: ${error.message}`,
                    showConfirmButton: false,
                    timer: 2000,
                });
            } finally {
                this.fetchingData = false
            }
        },
        handleDeleteSelection(item) {
            this.SET_ADDRESS(item)
            this.showDeleteAddressModal = true
        },
        handleUpdateSelection(item) {
            this.SET_ADDRESS(item)
            this.showUpdateAddressModal = true
        }
    },
    watch: {
        async page() {
            await this.fetchData()
        },
        async search() {
            this.page = 1
            await this.fetchData()
        }
    }
}
</script>

<style></style>